import React, { createContext, useState, useContext } from "react";

const AuthContext = createContext({
  username: "",
  email: "",
  sessionid: "",
  agenid: "3X5LBEVlKcVj7sjX4bnS",
  customerId: "",
  clientSecret: "",
  setAuthData: () => {},
});

export const AuthProvider = ({ children }) => {
  const [authData, setAuthData] = useState({
    username: "",
    email: "",
    sessionid: "",
    agenid: "3X5LBEVlKcVj7sjX4bnS",
    customerId: "",
    clientSecret: "",
  });

  return (
    <AuthContext.Provider value={{ ...authData, setAuthData }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
